// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WPkq","delete":"styles_delete__1dIP3","update":"styles_update__3dgXY","add":"styles_add__2Nt19"};